import {
  Button,
  makeStyles,
  Card,
  CardContent,
  Theme,
  Typography,
} from "@material-ui/core";
import React, { ReactElement, useEffect } from "react";
import Translator from "../services/Translator";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: theme.spacing(30),
    height: "61.8%",
    minHeight: theme.spacing(40),
    margin: "auto",
    boxSizing: "border-box",
  },
  logo: {
    height: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  card: {},
  cardContent: {
    display: "flex",
    flexDirection: "column",
    placeContent: "center",
    placeItems: "center",
    padding: theme.spacing(4),
  },
  button: {
    marginTop: theme.spacing(5),
  },
}));

function Login({
  onLogin,
  title,
}: {
  onLogin: () => void;
  title?: string;
}): ReactElement {
  const classes = useStyles();

  function handleLogin() {
    onLogin();
  }

  useEffect(() => {
    document.title = title || "VI Core | Login";
  }, [title]);

  return (
    <div className={classes.container}>
      <Card className={classes.card} variant="outlined" raised>
        <CardContent className={classes.cardContent}>
          <img
            className={classes.logo}
            src="/assets/images/Solera_Logo_CMYK-master.svg"
            alt="logo"
          />
          <Typography variant="h6">VI Core</Typography>
          <Button
            className={classes.button}
            size="small"
            color="secondary"
            variant="contained"
            onClick={handleLogin}
          >
            {Translator.translate("routes.login.login_text")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default Login;
